import type { ReactNode } from "react";
import { Link } from "react-router";

import { PepettesLogo } from "#guidelines/PepettesLogo";

export function AuthenticationLayout({
  title,
  children,
}: {
  title: string;
  children: ReactNode;
}) {
  return (
    <section className="bg-base-200 min-h-screen">
      <div className="mx-auto flex flex-col items-center justify-center px-6 py-8 md:h-screen lg:py-0">
        <Link to="/">
          <PepettesLogo />
        </Link>

        <div className="card bg-base-100 w-full shadow-xs sm:max-w-md md:mt-0 xl:p-0">
          <div className="card-body">
            <h2 className="card-title">{title}</h2>

            {children}
          </div>
        </div>
      </div>
    </section>
  );
}
